import { Avatar, Button } from "ui2";
import type { ESignatureValue } from "ui2";

import { initials } from "safety/components/attendance/format";
import { isSignatureReady, SignatureField } from "safety/components/attendance/SignatureField";
import { SubScreenHeader } from "safety/components/attendance/SubScreenHeader";

type ConfirmScreenProps = {
  meetingName: string;
  memberName: string;
  signature: ESignatureValue;
  submitting: boolean;
  onSignatureChange: (value: ESignatureValue) => void;
  onChangePin: () => void;
  onSubmit: () => void;
};

export const ConfirmScreen = ({
  meetingName,
  memberName,
  signature,
  submitting,
  onSignatureChange,
  onChangePin,
  onSubmit,
}: ConfirmScreenProps): React.JSX.Element => (
  <>
    <SubScreenHeader meetingName={meetingName} onBack={onChangePin} />
    <div className="tw:flex tw:w-full tw:flex-1 tw:flex-col tw:p-5">
      <div className="tw:text-sm tw:text-midnight/60">Signing in as</div>
      <div className="tw:mt-2 tw:flex tw:items-center tw:gap-3">
        <Avatar initials={initials(memberName)} size="lg" variant="full" />
        <div>
          <div className="tw:text-xl tw:font-denim tw:text-midnight">{memberName}</div>
          <Button className="tw:h-auto tw:p-0" variant="link" onClick={onChangePin}>
            Not you?
          </Button>
        </div>
      </div>
      <div className="tw:mt-6 tw:border-t tw:border-stroke tw:pt-5">
        <SignatureField value={signature} onChange={onSignatureChange} />
      </div>
      <div className="tw:mt-auto tw:pt-6">
        <Button
          size="lg"
          className="tw:w-full tw:sm:w-auto"
          disabled={!isSignatureReady(signature) || submitting}
          onClick={onSubmit}
        >
          Submit attendance
        </Button>
      </div>
    </div>
  </>
);
